import { useEffect } from 'react';
import { SITE_EVENTS, track } from './tracking';

/**
 * Zählt auf der Kundenwebsite, wenn jemand die Telefonnummer, den WhatsApp-Link
 * oder die E-Mail-Adresse antippt — egal, wo auf der Seite der Link steht.
 *
 * Ein Klick-Lauscher am Dokument statt eines `onClick` an jedem der rund
 * fünfzehn Links: Die Nummer steht im Kopf, im Fuß, im Kontaktblock, auf der
 * Kosten- und der 24h-Seite und in jeder Ortsseite, die noch dazukommt. Ein
 * Link, der die Zählung vergisst, fiele nirgends auf — hier kann er es nicht.
 *
 * Mitgeschickt werden die Seite (Pfad) und, falls der Link ein `data-stelle`
 * trägt, die Stelle darauf. Mehr nicht.
 */
export default function useConversionTracking(): void {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      try {
        const target = event.target as Element | null;
        const link = target?.closest?.('a[href]') as HTMLAnchorElement | null;
        if (!link) return;
        const href = link.getAttribute('href') ?? '';
        const name = href.startsWith('tel:')
          ? SITE_EVENTS.telefon
          : href.startsWith('https://wa.me/') || href.startsWith('https://api.whatsapp.com/')
            ? SITE_EVENTS.whatsapp
            : href.startsWith('mailto:')
              ? SITE_EVENTS.email
              : null;
        if (!name) return;
        const data: Record<string, string> = { seite: window.location.pathname };
        const stelle = link.dataset.stelle;
        if (stelle) data.stelle = stelle;
        track(name, data);
      } catch {
        /* Messung ist nie wichtiger als der Klick. */
      }
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
}
